import React, { useContext } from "react";
import WebtopLayoutContext from "../layout/WebtopLayoutContext";
import { getOpenNotes } from "../layout/layoutModel";
import StickyNote from "./StickyNote";

/**
 * StickyNotesLayer — renders the user's OPEN sticky notes on the desktop.
 * Closed notes are kept in storage (visible in the Sticky Notes app) but not
 * shown here. Sits above the icons but below the windows.
 */
const StickyNotesLayer = () => {
  const { layout } = useContext(WebtopLayoutContext);
  const notes = getOpenNotes(layout);
  if (!notes.length) return null;
  return (
    <div className="webtop-sticky-layer">
      {notes.map((note) => (
        <StickyNote key={note.id} note={note} />
      ))}
    </div>
  );
};

export default StickyNotesLayer;
